// returns LASTNAME Firstname
export const fullname = (firstname, lastname, joinWith = " ") => {
  if (!lastname && !firstname) return "";
  if (!lastname) {
    return capitalize(firstname.trim());
  }
  if (!firstname) {
    return lastname.trim().toUpperCase();
  }
  return lastname.trim().toUpperCase() + joinWith + capitalize(firstname.trim());
};

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Normalize, remove accents from a string and lowercase it.
 * Useful for comparison, used in autocomplete.
 * EX: "Crème brûlée" => "creme brulee"
 * @param {string} str
 * @returns {string}
 */
export function normalizeString(str) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}
